import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";
import { syllabi_comparison } from "@/router/sub_routes/institute/syllabi_comparison";
import { institute_students } from "@/router/sub_routes/institute/students";
import { institute_faculty } from "@/router/sub_routes/institute/faculty";

export const institute_routes: RouteConfig = {
  path: "/institute",
  component: () => import("@/views/modules/institute/Wrapper.vue"),
  meta: {
    user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
  },
  children: [
    {
      path: "",
      redirect: {
        name: "institute-dashboard"
      }
    },

    syllabi_comparison,
    // institute_students,
    // institute_faculty,
    {
      path: "error",
      name: "institute-error",
      component: () => import("@/views/ErrorPage.vue"),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    }
  ]
};
